module.exports = __webpack_public_path__ + "img/happy_holidays.19f795ac.svg";